export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8740.2dd4f7b9.jpg";